import Constants from "constants/index";
import IdentityService from "./indentity.service";

class MenuService extends IdentityService {
    public getAll = async (data: any) => {
        const result = await this.api.get({
            path: Constants.ApiPath.MENU.GET_ALL,
            query: data
        });
        return result.data.result;
    }

    public getPaged = async (data: any) => {
        const result = await this.api.get({
            path: `${Constants.ApiPath.MENU.GET_PAGED}?${data}`,
        });
        return result.data.result;
    }

    public getDetail = async (id: string) => {
        const result = await this.api.get({
            path: Constants.ApiPath.MENU.GET_DETAIL + `/${id}`,
        });
        return result.data.result;
    }

    public create = async (data: any) => {
        const result = await this.api.post({
            path: Constants.ApiPath.MENU.CREATE,
            data: data
        });
        return result.data;
    }

    public update = async (data: any) => {
        const result = await this.api.post({
            path: Constants.ApiPath.MENU.UPDATE,
            data: data
        });
        return result.data;
    }

    public delete = async (data: any) => {
        const result = await this.api.delete({
            path: Constants.ApiPath.MENU.DELETE,
            data: data
        });
        return result.data;
    }

}

export default MenuService;